import chatService from '@/services/chat';
import * as types from './types';

import {
  SET_CLIENT_ROOM,
  SET_UNREAD_COUNT,
  SET_EMPLOYEE_ROOMS,
  SET_EMPLOYEE_ROOMS_WITH_OWNERS,
  SET_EMPLOYEE_ROOMS_WITH_TENANTS,
  SET_EMPLOYEE_ROOMS_WITH_OTHER_CLIENTS,
  SET_PARTICIPANTS,
} from '../mutations/types';

export default {
  [types.SET_CLIENT_ROOM]: ({ commit }, roomData) => {
    commit(SET_CLIENT_ROOM, roomData.rooms[0].roomId);
    commit(SET_UNREAD_COUNT, roomData.rooms[0].unreadMessageCount);
    commit(SET_PARTICIPANTS, roomData.rooms[0].participants);
  },

  [types.SET_EMPLOYEE_ROOM]: ({ commit }, roomData) => {
    const ownerRooms = [];
    const tenantRooms = [];
    const otherRooms = [];
    roomData.rooms.forEach(room => {
      switch (room.client.clientType) {
        case 'owner':
          ownerRooms.push(room);
          break;
        case 'all':
          ownerRooms.push(room);
          break;
        case 'tenant':
          tenantRooms.push(room);
          break;
        default:
          otherRooms.push(room);
          break;
      }
    });
    commit(
      SET_EMPLOYEE_ROOMS,
      roomData.rooms.map(room => chatService.normalizeRoomData(room))
    );
    commit(
      SET_EMPLOYEE_ROOMS_WITH_OWNERS,
      ownerRooms.map(room => chatService.normalizeRoomData(room))
    );
    commit(
      SET_EMPLOYEE_ROOMS_WITH_TENANTS,
      tenantRooms.map(room => chatService.normalizeRoomData(room))
    );
    commit(
      SET_EMPLOYEE_ROOMS_WITH_OTHER_CLIENTS,
      otherRooms.map(room => chatService.normalizeRoomData(room))
    );
    commit(SET_UNREAD_COUNT, roomData.unreadChatCount);
  },
};
